<template>
  <el-date-picker
    v-if="type === 'daterange'"
    v-model="value"
    class="hx-date-picker-range"
    type="daterange"
    range-separator="~"
    format="yyyy-MM-dd"
    :value-format="valueFormat"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    :picker-options="pickerOptions"
    v-bind="$attrs"
  >
    <slot></slot>
  </el-date-picker>
  <div v-else-if="type === 'date'" class="hx-date-picker-range__inline">
    <el-date-picker
      :value="start"
      class="hx-date-picker-range"
      type="date"
      format="yyyy-MM-dd"
      :value-format="valueFormat"
      placeholder="开始时间"
      @input="$emit('update:start', $event)"
    >
      <slot></slot>
    </el-date-picker>
    <span class="hx-date-picker-range__hyphen">-</span>
    <el-date-picker
      :value="end"
      class="hx-date-picker-range"
      type="date"
      format="yyyy-MM-dd"
      :value-format="valueFormat"
      placeholder="结束时间"
      @input="$emit('update:end', $event)"
    >
      <slot></slot>
    </el-date-picker>
  </div>
</template>

<script>
import moment from 'moment/moment'

const noop = () => {}

export default {
  name: 'HxDatePickerRange',

  componentName: 'ElTimeSelect',

  props: {
    type: {
      type: String,
      default: 'daterange',
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss',
    },
    start: {},
    end: {},
    defaultCurrentMonth: {
      type: Boolean,
      default: false,
    },
    defaultOneMonth: {
      type: Boolean,
      default: false,
    },
    disabledDate: Function,
  },

  data() {
    return {
      customPickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const d = new Date()
              const end = new Date(
                d.getFullYear(),
                d.getMonth(),
                d.getDate(),
                23,
                59,
                59,
              )
              const start = new Date(
                d.getFullYear(),
                d.getMonth(),
                d.getDate(),
                0,
                0,
                0,
              )
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick: (picker) => {
              const d = new Date()
              const end = new Date(
                d.getFullYear(),
                d.getMonth(),
                d.getDate(),
                23,
                59,
                59,
              )
              const start = new Date(
                d.getFullYear(),
                d.getMonth(),
                d.getDate(),
                0,
                0,
                0,
              )
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const d = new Date()
              const end = new Date(
                d.getFullYear(),
                d.getMonth(),
                d.getDate(),
                23,
                59,
                59,
              )
              const start = new Date(
                d.getFullYear(),
                d.getMonth(),
                d.getDate(),
                0,
                0,
                0,
              )
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },

  computed: {
    pickerOptions() {
      if (this.disabledDate) {
        return {
          disabledDate: this.disabledDate,
        }
      } else {
        return this.customPickerOptions
      }
    },
    value: {
      get() {
        return [this.start, this.end]
      },
      set(val) {
        if (val) {
          let endTime = val[1]
          if (this.valueFormat !== 'timestamp') {
            endTime = this.setEndTime(val[1])
          } else {
            endTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
            endTime = new Date(this.setEndTime(endTime)).getTime()
          }

          this.$emit('update:start', val[0])
          this.$emit('update:end', endTime)
        } else {
          if (this.valueFormat === 'timestamp') {
            this.$emit('update:start', undefined)
            this.$emit('update:end', undefined)
          } else {
            this.$emit('update:start', '')
            this.$emit('update:end', '')
          }
        }
      },
    },
  },

  watch: {
    start(val) {
      if (!val && this.type === 'daterange') {
        this.$emit('update:end', val)
      }
    },
    end(val) {
      if (!val && this.type === 'daterange') {
        this.$emit('update:start', val)
      }
    },
  },

  updated() {},

  mounted() {
    if (this.defaultOneMonth) {
      this.$on('fieldReset', () => {
        this.setOneMonth()
      })
      this.setOneMonth()
    }

    if (this.defaultCurrentMonth) {
      this.$on('fieldReset', () => {
        this.setCurrentMonth()
      })
      this.setCurrentMonth()
    }
  },

  methods: {
    setEndTime(val) {
      const end = val.replace('00', '23').replace(/00/g, '59')

      return end
    },

    setCurrentMonth() {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth()
      const day = d.getDate()
      let start = new Date(year, month, 1, 0, 0, 0)
      let end = new Date(year, month, day, 23, 59, 59)

      start = moment(start).format('YYYY-MM-DD HH:mm:ss')
      end = moment(end).format('YYYY-MM-DD HH:mm:ss')

      this.value = [start, end]
    },

    setOneMonth() {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth()
      const day = d.getDate()
      let start = new Date(year, month, day, 0, 0, 0)
      let end = new Date(year, month, day, 23, 59, 59)

      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)

      start = moment(start).format('YYYY-MM-DD HH:mm:ss')
      end = moment(end).format('YYYY-MM-DD HH:mm:ss')

      this.value = [start, end]
    },
  },
}
</script>
